import React, { Component } from 'react';
import { Button, Form, Input, Modal, Select, Upload } from 'antd';
import { AlignRightOutlined, UploadOutlined } from '@ant-design/icons';
import cloneDeep from 'lodash/cloneDeep';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';

class CategoryForm extends Component {
    constructor() {
        super();

        this.state = {
            fileList: []
        };

        this.formRef = React.createRef();
    }

    handleSubmit = () => {
        this.formRef.current.validateFields()
            .then(values => {
                const formData = new FormData();

                formData.append('name', values.name);

                if (values.image.fileList) {
                    const { fileData } = this.state;
                    formData.append('image', fileData, fileData.name);
                }

                if (this.state.subMode)
                    formData.append('subCategory', values.subCategory);

                this.props.onSubmit(formData);
            });
    }

    handleWillUnmount = () => {
        this.formRef.current.resetFields();

        this.setState({ fileList: [] });
    }

    handleDidMount = (data = {}, subMode) => {
        const cloneData = cloneDeep(data);

        cloneData.subCategory = cloneData.subCategory ? parseInt(cloneData.subCategory) : cloneData.subCategory;

        this.formRef.current.setFieldsValue(cloneData);

        this.setState({ editMode: !!cloneData.id, subMode: !!subMode });
    }

    render() {
        const { mainCats, onCancel, submitting, visible } = this.props;
        const { fileList, editMode, subMode } = this.state;

        const props = {
            onRemove: file => {
                this.setState(state => {
                    const index = state.fileList.indexOf(file);
                    const newFileList = state.fileList.slice();
                    newFileList.splice(index, 1);
                    return { fileList: newFileList };
                });
            },
            beforeUpload: file => {
                this.setState({ fileList: [file], fileData: file });
                return false;
            },
            fileList
        };

        return (
            <Modal
                title={`${editMode ? Resources.edit : Resources.add} ${Resources.category} ${subMode ? Resources.sub : Resources.main}`}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={onCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={360}>
                <Form ref={this.formRef} layout="vertical">
                    <Form.Item name="name" label={Resources.title} rules={Rules.required}>
                        <Input type="text" prefix={<AlignRightOutlined />} />
                    </Form.Item>
                    {subMode && <Form.Item name="subCategory" label={`${Resources.category} ${Resources.main}`} rules={Rules.required}>
                        <Select
                            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            placeholder={Resources.filterByMainCat}
                            onChange={this.handleFilter}
                            style={{ display: 'block' }}
                            showSearch>
                            {mainCats.map(cat => <Select.Option key={cat.id} value={cat.id}>{cat.name}</Select.Option>)}
                        </Select>
                    </Form.Item>}
                    <Form.Item name="image" label={Resources.image} rules={editMode ? [] : Rules.required}>
                        <Upload {...props} className="ant-upload-block">
                            <Button block><UploadOutlined /> {Resources.chooseImage}</Button>
                        </Upload>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
};

export default CategoryForm;